export interface User {
    id: string;
    username: string;
    role: string;
    password?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
}

export enum UserRole {
    ADMIN = 'admin',
    CUSTOMER = 'customer',
    ACCOUNTANT = 'accountant', // Abrechner in German - can manage events, orders, invoices
}